<template>
  <div class="page" style="padding-top:65px;">
    <div class="intro">
      <div class="container">
        <div class="intro-title">强劲实力，成就客户</div>
        <div class="intro-msg">行业头部品牌商家数字化增长的口碑之选</div>
        <div class="intro-but">
          <el-button type="primary" @click="openModal">免费试用</el-button>
          <el-button type="primary" @click="openModal">立即咨询</el-button>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="tabs">
        <div class="tabs-item" @click="checktab(1)">
          <img src="@/assets/new/all_active.png" alt="" v-if="activeIndex == 1" />
          <img src="@/assets/new/all.png" alt="" v-else />
          <span :style="{ color: activeIndex == 1 ? '#F54C41' : '#333' }">全部</span>
        </div>
        <div class="tabs-item" @click="checktab(2)">
          <img src="@/assets/new/retail_active.png" alt="" v-if="activeIndex == 2" />
          <img src="@/assets/new/retail.png" alt="" v-else />
          <span :style="{ color: activeIndex == 2 ? '#F54C41' : '#333' }">零售</span>
        </div>
        <div class="tabs-item" @click="checktab(3)">
          <img src="@/assets/new/catering_active.png" alt="" v-if="activeIndex == 3" />
          <img src="@/assets/new/catering.png" alt="" v-else />
          <span :style="{ color: activeIndex == 3 ? '#F54C41' : '#333' }">餐饮</span>
        </div>
      </div>

      <div class="main">
        <div class="list" v-if="activeIndex == 1">
          <div class="list-item">
            <div class="item-left">
              <div class="left-title">
                <div class="title-ico">
                  <img src="@/assets/new/wanjia.png" alt="" />
                </div>
                <div class="title-name">
                  <h4>
                    万嘉便利店
                    <span class="title-name-type">零售</span>
                  </h4>
                </div>
              </div>
              <div class="left-text">
                <h5>万嘉超市有限公司成立于2000年</h5>
                <span>是一家生鲜与便利结合的现代综合连锁便利 超市，经营商品万余种，为社会提供20多个 就业岗位，是福州市拥有门店最多的知名零 售连锁企业。</span>
              </div>
              <div class="left-sum">
                <div>
                  <h3>100+</h3>
                  <p>经营门店</p>
                </div>
                <div>
                  <h3>500万+</h3>
                  <p>顾客人群</p>
                </div>
              </div>
              <div class="min-btn">
                <el-button type="primary" class="back-red" @click="openModal">免费试用</el-button>
                <el-button type="primary" class="border-red" @click="openModal">立即咨询</el-button>
              </div>
            </div>
            <div class="item-right">
              <img src="@/assets/new/wanjia_b.png" alt="">
            </div>
          </div>

          <div class="list-item">
            <div class="item-left">
              <div class="left-title">
                <div class="title-ico">
                  <img src="@/assets/new/haixian.png" alt="" />
                </div>
                <div class="title-name">
                  <h4>
                    1718
                    <span class="title-name-type">餐饮</span>
                  </h4>
                </div>
              </div>
              <div class="left-text">
                <h5>海鲜火锅</h5>
                <span>用简单的烹饪方式保留住海鲜的原汁原味， 才不会辜负好料理。优选新鲜的海鲜食材， 匠心制作，没有人能抗拒一桌美味的海鲜</span>
              </div>
              <div class="left-sum">
                <div>
                  <h3>13家</h3>
                  <p>连锁门店</p>
                </div>
                <div>
                  <h3>100万+</h3>
                  <p>顾客人群</p>
                </div>
              </div>
              <div class="min-btn">
                <el-button type="primary" class="back-red" @click="openModal">免费试用</el-button>
                <el-button type="primary" class="border-red" @click="openModal">立即咨询</el-button>
              </div>
            </div>
            <div class="item-right">
              <img src="@/assets/new/haixian_b.png" alt="">
            </div>
          </div>

          <div class="list-item">
            <div class="item-left">
              <div class="left-title">
                <div class="title-ico">
                  <img src="@/assets/new/fulong.png" alt="" />
                </div>
                <div class="title-name">
                  <h4>
                    福龙客车
                    <span class="title-name-type">餐饮</span>
                  </h4>
                </div>
              </div>
              <div class="left-text">
                <h5>福州开发区福龙客车有限公司</h5>
                <span>主营行业为交通运输、仓储和邮政业，服务 领域为铁路客、货运输服务。中餐类制售， 零售预包装食品批准的项目</span>
              </div>
              <div class="left-sum">
                <div>
                  <h3>10+</h3>
                  <p>经营种类</p>
                </div>
                <div>
                  <h3>1亿+</h3>
                  <p>服务人群</p>
                </div>
              </div>
              <div class="min-btn">
                <el-button type="primary" class="back-red" @click="openModal">免费试用</el-button>
                <el-button type="primary" class="border-red" @click="openModal">立即咨询</el-button>
              </div>
            </div>
            <div class="item-right">
              <img src="@/assets/new/fulong_b.png" alt="">
            </div>
          </div>

          <div class="list-item">
            <div class="item-left">
              <div class="left-title">
                <div class="title-ico">
                  <img src="@/assets/new/niupai.png" alt="" />
                </div>
                <div class="title-name">
                  <h4>
                    盛世经典牛排
                    <span class="title-name-type">餐饮</span>
                  </h4>
                </div>
              </div>
              <div class="left-text">
                <h5>海鲜火锅</h5>
                <span>2003年，盛世经典品牌正式创立，总部座 落于福建省会城市—福州。始终秉承着“健 康快乐每一天”的经营理念</span>
              </div>
              <div class="left-sum">
                <div>
                  <h3>80家</h3>
                  <p>连锁门店</p>
                </div>
                <div>
                  <h3>1000万+</h3>
                  <p>顾客人群</p>
                </div>
              </div>
              <div class="min-btn">
                <el-button type="primary" class="back-red" @click="openModal">免费试用</el-button>
                <el-button type="primary" class="border-red" @click="openModal">立即咨询</el-button>
              </div>
            </div>
            <div class="item-right">
              <img src="@/assets/new/niupai_b.png" alt="">
            </div>
          </div>
        </div>

        <div class="list" v-if="activeIndex == 2">
          <div class="list-item">
            <div class="item-left">
              <div class="left-title">
                <div class="title-ico">
                  <img src="@/assets/new/wanjia.png" alt="" />
                </div>
                <div class="title-name">
                  <h4>
                    万嘉便利店
                    <span class="title-name-type">零售</span>
                  </h4>
                </div>
              </div>
              <div class="left-text">
                <h5>万嘉超市有限公司成立于2000年</h5>
                <span>是一家生鲜与便利结合的现代综合连锁便利 超市，经营商品万余种，为社会提供20多个 就业岗位，是福州市拥有门店最多的知名零 售连锁企业。</span>
              </div>
              <div class="left-sum">
                <div>
                  <h3>100+</h3>
                  <p>经营门店</p>
                </div>
                <div>
                  <h3>500万+</h3>
                  <p>顾客人群</p>
                </div>
              </div>
              <div class="min-btn">
                <el-button type="primary" class="back-red" @click="openModal">免费试用</el-button>
                <el-button type="primary" class="border-red" @click="openModal">立即咨询</el-button>
              </div>
            </div>
            <div class="item-right">
              <img src="@/assets/new/wanjia_b.png" alt="">
            </div>
          </div>
        </div>

        <div class="list" v-if="activeIndex == 3">
          <div class="list-item">
            <div class="item-left">
              <div class="left-title">
                <div class="title-ico">
                  <img src="@/assets/new/haixian.png" alt="" />
                </div>
                <div class="title-name">
                  <h4>
                    1718
                    <span class="title-name-type">餐饮</span>
                  </h4>
                </div>
              </div>
              <div class="left-text">
                <h5>海鲜火锅</h5>
                <span>用简单的烹饪方式保留住海鲜的原汁原味， 才不会辜负好料理。优选新鲜的海鲜食材， 匠心制作，没有人能抗拒一桌美味的海鲜</span>
              </div>
              <div class="left-sum">
                <div>
                  <h3>13家</h3>
                  <p>连锁门店</p>
                </div>
                <div>
                  <h3>100万+</h3>
                  <p>顾客人群</p>
                </div>
              </div>
              <div class="min-btn">
                <el-button type="primary" class="back-red" @click="openModal">免费试用</el-button>
                <el-button type="primary" class="border-red" @click="openModal">立即咨询</el-button>
              </div>
            </div>
            <div class="item-right">
              <img src="@/assets/new/haixian_b.png" alt="">
            </div>
          </div>
          <div class="list-item">
            <div class="item-left">
              <div class="left-title">
                <div class="title-ico">
                  <img src="@/assets/new/fulong.png" alt="" />
                </div>
                <div class="title-name">
                  <h4>
                    福龙客车
                    <span class="title-name-type">餐饮</span>
                  </h4>
                </div>
              </div>
              <div class="left-text">
                <h5>福州开发区福龙客车有限公司</h5>
                <span>主营行业为交通运输、仓储和邮政业，服务 领域为铁路客、货运输服务。中餐类制售， 零售预包装食品批准的项目</span>
              </div>
              <div class="left-sum">
                <div>
                  <h3>10+</h3>
                  <p>经营种类</p>
                </div>
                <div>
                  <h3>1亿+</h3>
                  <p>服务人群</p>
                </div>
              </div>
              <div class="min-btn">
                <el-button type="primary" class="back-red" @click="openModal">免费试用</el-button>
                <el-button type="primary" class="border-red" @click="openModal">立即咨询</el-button>
              </div>
            </div>
            <div class="item-right">
              <img src="@/assets/new/fulong_b.png" alt="">
            </div>
          </div>
          <div class="list-item">
            <div class="item-left">
              <div class="left-title">
                <div class="title-ico">
                  <img src="@/assets/new/niupai.png" alt="" />
                </div>
                <div class="title-name">
                  <h4>
                    盛世经典牛排
                    <span class="title-name-type">餐饮</span>
                  </h4>
                </div>
              </div>
              <div class="left-text">
                <h5>海鲜火锅</h5>
                <span>2003年，盛世经典品牌正式创立，总部座 落于福建省会城市—福州。始终秉承着“健 康快乐每一天”的经营理念</span>
              </div>
              <div class="left-sum">
                <div>
                  <h3>80家</h3>
                  <p>连锁门店</p>
                </div>
                <div>
                  <h3>1000万+</h3>
                  <p>顾客人群</p>
                </div>
              </div>
              <div class="min-btn">
                <el-button type="primary" class="back-red" @click="openModal">免费试用</el-button>
                <el-button type="primary" class="border-red" @click="openModal">立即咨询</el-button>
              </div>
            </div>
            <div class="item-right">
              <img src="@/assets/new/niupai_b.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog ref="dialog"></Dialog>
  </div>
</template>

<script>
import Dialog from './dialog';
export default {
  name: "Cooperation",
  components:{
    Dialog
  },
  data() {
    return {
      activeIndex: 1,
      dialogVisible:false
    };
  },
  methods: {
    openModal(){
      this.$refs.dialog.openLog()
    },
    checktab(a) {
      if (a) {
        this.activeIndex = a;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  width: 100%;
  background-color: #f5f8ff;
}
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.intro {
  background: url(../assets/new/cooperation_bg.jpg) no-repeat center;
  background-size: cover;
  padding: 60px 0;
  color: #fff;
  display: flex;
  align-items: center;
}
.intro-title {
  font-size: 28px;
  margin-bottom: 20px;
  color: #fff;
}
.intro-msg {
  font-size: 16px;
  color: #fff;
}
.intro-but {
  margin-top: 30px;
  display: flex;
  gap: 15px;
}
.intro-but button:nth-of-type(1) {
  color: #de1f26;
  background-color: #fff;
  border: 1px solid #de1f26;
}
.intro-but button:nth-of-type(2) {
  color: #fff;
  background-color: #de1f26;
  border: 1px solid #fff;
}

.tabs {
  padding: 30px 0;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  gap: 40px;
  .tabs-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 16px;
    color: #333;
    cursor: pointer;
    img {
      width: 50px;
      height: 50px;
      margin-bottom: 8px;
    }
  }
}

.main {
  padding-bottom: 40px;
}
.list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
}
.list-item {
  width: 100%;
  max-width: 618px;
  background: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-radius: 8px;
  overflow: hidden;
}
.item-left {
  width: 100%;
  position: relative;
}
.item-right {
  width: 100%;
  height: 200px;
  overflow: hidden;
  border-radius: 6px;
}
.item-right img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.left-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.title-ico {
  width: 50px;
  height: 50px;
}
.title-ico img {
  width: 100%;
  height: 100%;
}
.title-name h4 {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}
.title-name-type {
  font-size: 14px;
  color: #aaa;
  padding-left: 8px;
  border-left: 1px solid #aaa;
  font-weight: 400;
}

.left-text {
  margin-top: 16px;
}
.left-text h5 {
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
}
.left-text span {
  font-size: 14px;
  color: #767676;
  line-height: 1.6;
}

.left-sum {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.left-sum div h3 {
  font-size: 22px;
  color: #de1f26;
}
.left-sum div p {
  font-size: 14px;
  color: #1a1a1a;
  margin-top: 4px;
}

.min-btn {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}
.min-btn .back-red {
  flex: 1;
  height: 44px;
  background: #de1f26;
  color: #fff;
  border: none;
  border-radius: 4px;
}
.min-btn .border-red {
  flex: 1;
  height: 44px;
  background: #fff;
  color: #de1f26;
  border: 1px solid #de1f26;
  border-radius: 4px;
}

h3,h4,h5,p {
  margin: 0;
  padding: 0;
}

/* ====================== PC端 ====================== */
@media (min-width: 768px) {
  .intro {
    height: 500px;
    padding: 0;
  }
  .intro-title {
    font-size: 48px;
  }
  .intro-msg {
    font-size: 20px;
  }
  .intro-but {
    margin-top: 50px;
  }

  .list-item {
    flex-direction: row;
    padding: 30px;
    height: 420px;
  }
  .item-left {
    width: 280px;
    margin-right: 30px;
  }
  .item-right {
    width: 320px;
    height: 100%;
  }

  .min-btn {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}
</style>
